import React from "react"

function SidebarHeading({ headerText }) {
  return <h3>{headerText}</h3>
}

export default SidebarHeading
